import _taggedTemplateLiteral from "/home/jenkins/workspace/terra.b2c.webui.register_staging/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
export var StyledHeader = styled.div(_templateObject(), function (props) {
  return "\n        position: fixed;\n        top: 0;\n        right: 0;\n        transition: ".concat(props.theme.components.header.transition, ";\n        width: ").concat(props.width, ";\n        max-width: 100%;\n        height: ").concat(props.theme.components.header.height, ";\n        background-color:  ").concat(props.theme.components.header.backgroundColor, ";\n        box-shadow: ").concat(props.shadow ? '0 10px 10px -10px rgba(0,0,0,0.25)' : 'none', ";\n        display: flex;\n        z-index: ").concat(props.theme.components.header.zIndex, ";\n        ").concat(props.visible ? "visibility: visible; top: 0px;" : "visibility: hidden; top: -".concat(props.theme.components.header.height, ";"), "\n    ");
});